import handleNewsFilter from "util/handleNewsFilter";

$(function () {
    handleNewsFilter();
});
